import React, {useState, useEffect} from "react"
import { useNavigate } from "react-router-dom"
import { buildMiiDescriptions } from "../defaults"
import { v4 as uuidv4 } from 'uuid'
import logoMii from '../../assets/images/mmiilogo.png'
import BuildMiiImageViewer from './buildMiiImageViewer'

const BuildMii = (props) => {
    const { hoveredBuildMiiPage, handleBuildMiiHoverToggle } = props
    const [hoveredBuildMii,setHoveredBuildMii] = useState(false)
    const navigate = useNavigate()
    const uId_token = uuidv4();
    
    const handleHovering = (isHovered) => {
        handleBuildMiiHoverToggle(isHovered)
        setHoveredBuildMii(isHovered)
    }

    const handleBuildMiiClick = () => {
        navigate(`/TypeForm/form/${process.env.REACT_APP_TYPEFORM_FORM_ID}`)
    }

    return(
        <div className="flex flex-col h-full w-full bg-white-900">
            <div className="flex flex-row h-full">
                <div className="flex flex-col h-full w-1/2 self-center p-4">
                    <div className="flex flex-col h-full w-full ">
                        <div className="px-6 py-4">
                            <div className="font-bold text-6xl text-homepage-label mb-5">{buildMiiDescriptions.label}</div>
                        </div>
                    </div>
                    <div className="flex flex-col h-full w-full">
                        <div className="px-6 py-4">
                            <p className="text-black text-xl">
                                {buildMiiDescriptions.description}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col h-full w-[35%] ml-[10rem]">
                        <button
                            className={`text-white-700  py-2 px-8 rounded-full ${
                                hoveredBuildMii ? "bg-blue-700" : "bg-gradient-to-r from-homepage-buildmii-btnbg1 to-homepage-buildmii-btnbg2"
                            }`}
                            onMouseEnter={() => handleHovering(true)}
                            onMouseLeave={() => handleHovering(false)}
                            onClick={handleBuildMiiClick}
                            >
                            {/* <a href={`${process.env.REACT_APP_TYPEFORM_URL}/${process.env.REACT_APP_TYPEFORM_FORM_ID}#u_id=${uId_token}&form_id=${process.env.REACT_APP_TYPEFORM_FORM_ID}`}> */}
                                Lets Build  your Job Description
                            {/* </a> */}
                        </button>
                    </div>
                </div>
                <div className="flex h-full w-1/2 p-4 text-center">
                    <div className="flex h-full w-full justify-center items-center ">
                        <BuildMiiImageViewer />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BuildMii